// removed by extract-text-webpack-plugin
module.exports = {"container":"MobileImageContainer__container___3GL8q","screen":"MobileImageContainer__screen___DPYxd","mobileImgContainer":"MobileImageContainer__mobileImgContainer___1SVdu","screenImg":"MobileImageContainer__screenImg___1CbsW"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/MobileImageContainer.css
// module id = 1562
// module chunks = 0